//timer module
export default {
    namespaced: true,
    state: {
        endTime: null,
        minutes: 0,
        seconds: 0,
        interval: null,
        timeExpired: false,
    },
    mutations: {
        SET_TIME_EXPIRED(state, value) {
            state.timeExpired = value;
        },
        SET_MINUTES(state, value) {
            state.minutes = value;
        },
        SET_SECONDS(state, value) {
            state.seconds = value;
        },
        SET_END_TIME(state, value) {
            state.endTime = value;
        },
    },
    actions: {
        setTimeExpired({ commit }, value) {
            commit("SET_TIME_EXPIRED", value);
        },
        setMinutes({ commit }, value) {
            commit("SET_MINUTES", value);
        },
        setSeconds({ commit }, value) {
            commit("SET_SECONDS", value);
        },
        setEndTime({ commit }, value) {
            commit("SET_END_TIME", value);
        }
    },
    getters: {
        getTimeExpired: (state) => state.timeExpired,
        getMinutes: (state) => state.minutes,
        getSeconds: (state) => state.seconds,
        getEndTime: (state) => state.endTime,
        getFormattedMinutes: (state) => String(state.minutes).padStart(2, "0"),
        getFormattedSeconds: (state) => String(state.seconds).padStart(2, "0")
    },
};
